<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form :inline="true">
        <el-form-item :label="item.label" v-for="item in hospitalAllFilter" :key="item.label">
          <el-date-picker
            type="datetimerange"
            v-if="item.type === 'datetimerange'"
            v-model="form[item.start + '_' + item.end]"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
          ></el-date-picker>
          <el-cascader v-else-if="item.type === 'cascader'" :props="cascaderPropsSearch" :options="options" v-model="form[item.prop]" clearable></el-cascader>
          <el-input v-else v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="handleAdd">添加</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe :data="tableData">
        <el-table-column :label="item.label" v-for="item in hospitalAllTable" :key="item.label">
          <template slot-scope="scope">
            <span v-if="item.filter">{{ item.filter(scope.row) }}</span>
            <img v-else-if="item.prop === 'logo'" style="width: 140px" :src="scope.row[item.prop]" alt="logo">
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        @current-change="onPageChange"></el-pagination>
    </div>
    <el-dialog
      :title="isAdd ? '添加医院' : '编辑医院'"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px" class="addForm">
        <el-form-item label="省/市" prop="provinceCity">
          <el-cascader :props="cascaderProps" :options="options" v-model="addForm.provinceCity" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="医院" prop="name">
          <el-input placeholder="请输入医院名称" v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="医院缩写" prop="abbr">
          <el-input placeholder="请输入医院缩写" v-model="addForm.abbr"></el-input>
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <el-upload
            class="avatar-uploader"
            action="/api/upload/image"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="addForm.logo" :src="addForm.logo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          （56*52或112*104）
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm', true)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as R from 'ramda';
import { task as taskApi } from '@/api';
import moment from 'moment';
import { areas } from '@/utils/areas';

export default {
  name: 'hospitalManage',
  data() {
    return {
      dialogVisible: false,

      options: areas,

      cascaderPropsSearch: {
        checkStrictly: true,
        value: 'code',
        label: 'name'
      },
      cascaderProps: {
        value: 'code',
        label: 'name'
      },
      addForm: {
        provinceCity: [],
        abbr: '',
        name: '',
        verify: '',
        localId: '',
        logo: ''
      },

      addRules: {
        name: [
          { required: true, message: '请输入医院名称', trigger: 'blur' },
        ],
        provinceCity: [
          { type: 'array', required: true, message: '请选择省市', trigger: 'change' },
        ],
        abbr: [
          { type: 'regexp', required: true, message: '请输入医院缩写', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              let patt = /^[A-Z]{4}$/;
              if (!patt.test(value)) {
                callback(new Error('限定4个大写字母'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },

      hospitalAllFilter: [],
      hospitalAllTable: [],

      form: {},

      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,

      tableData: [],

      isAdd: true
    };
  },
  computed: {
    operates: ({ $route }) => $route.meta.operates,
  },
  methods: {
    handleAdd() {
      this.isAdd = true;
      this.dialogVisible = true;
      this.addForm = {
        provinceCity: [],
        name: '',
        verify: '',
        localId: '',
        logo: ''
      };
      this.$refs.addForm && this.$refs.addForm.clearValidate();
    },
    handleAvatarSuccess(res) {
      this.addForm.logo = res.data;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleEdit(row) {
      this.isAdd = false;
      this.addForm.provinceCity = [String(row.provinceId), String(row.cityId)];
      this.addForm.name = row.name;
      this.addForm.abbr = row.abbr;
      this.addForm.localId = row.localId;
      this.addForm.orderAbbr = row.orderAbbr;
      this.addForm.logo = row.logo;
      this.dialogVisible = true;
    },
    async lazyLoad(node, resolve) {
      const { data } = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(data.map(e => ({
        value: e.code,
        label: e.name,
        leaf: e.level >= 2
      })));
    },
    handleStatus(localId, status) {
      taskApi.hospitalDisable({
        localId,
        status
      })
        .then((res) => {
          if (res.code === 10000) {
            if (status === 1) {
              this.$message.success('解冻代理商账号成功！');
            } else {
              this.$message.success('冻结代理商账号成功！');
            }
            this.onSearch();
          }
        });
    },
    getForm() {
      const { hospitalAllFilter } = this.$route.meta;
      const form = {};
      R.forEach(({ type, prop, start, end }) => {
        form[prop] = '';
      }, hospitalAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const { onClick } = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const { hospitalAllFilter, hospitalAllTable } = this.$route.meta;
      this.hospitalAllFilter = hospitalAllFilter;
      this.hospitalAllTable = hospitalAllTable;
      this.getForm();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            name: this.addForm.name,
            logo: this.addForm.logo,
            abbr: this.addForm.abbr,
            orderAbbr: String(+new Date()),
            province: this.addForm.provinceCity[0],
            city: this.addForm.provinceCity[1]
          };
          if (!this.isAdd) {
            params.localId = this.addForm.localId;
            params.verify = this.addForm.verify;
            params.orderAbbr = this.addForm.orderAbbr;
          }
          taskApi[this.isAdd ? 'hospitalAdd' : 'hospitalUpdate'](params)
            .then(res => {
              if (res.code === 10000) {
                this.$message.success('操作成功！');
                this.onSearch();
                this.dialogVisible = false;
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancle() {
      this.resetForm('ruleForm');
      this.visible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async query(pageNo = 1) {
      const { fetchDataName } = this.$route.meta;
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem = R.find(R.propEq('prop', key), this.hospitalAllFilter) || {};
        if (/_/.test(key)) { // 是 datetimerange
          if (R.isEmpty(value)) return;
          const [ startKey, endKey ] = key.split('_');
          const [ startValue, endValue ] = value;
          submitForm[startKey] = moment(startValue).format('YYYY-MM-DD HH:mm:ss');
          submitForm[endKey] = moment(endValue).format('YYYY-MM-DD HH:mm:ss');
        } else if (key === 'provinceCity') {
          const [ provinceId, cityId ] = value;
          submitForm['provinceId'] = provinceId;
          submitForm['cityId'] = cityId;
        } else {
          submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value);
        }
      }, this.form);
      // console.log(this.form, submitForm);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach((key) => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && (value !== '')) ||
          (R.is(Number, value))
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['hospitalListName'];
        const { status } = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const { pageCount, data, count } = res.data;
        this.pageCount = pageCount;
        this.pageTotal = count;
        this.tableData = data;
      }
    },
  },
  created() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/HospitalManage/index.vue